import { render } from "./chat-panel.vue?vue&type=template&id=e8df5096&scoped=true&ts=true&lang=pug"
import script from "./chat-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./chat-panel.vue?vue&type=script&setup=true&lang=ts"

import "./chat-panel.vue?vue&type=style&index=0&id=e8df5096&lang=stylus&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8df5096"]])

export default __exports__